export default __webpack_public_path__ + "static/logotype-black-4ca3cf3d50249fb25b3204fceeff90d0.svg";